const uuidRegex = new RegExp("([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})");

export function isUUID(value) {
  if (!value) {
    return false
  }

  return (value + '').match(uuidRegex)
}



// WEBPACK FOOTER //
// ./src/helpers/props.js